import React from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

const CTASection = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-primary via-secondary to-primary relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-accent rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-accent rounded-full blur-3xl" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center max-w-4xl mx-auto">
          <h2 className="text-4xl lg:text-5xl font-headline font-bold text-primary-foreground mb-6 leading-tight">
            Your Compassion Creates
            <span className="block text-peaceful-teal mt-2">Lasting Transformation</span>
          </h2>
          
          <p className="text-xl text-primary-foreground/90 mb-8 leading-relaxed font-body">
            Together, we can create a world where every person has access to dignity, hope, and opportunity.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
            <Link href="/donate" className="px-8 py-4 bg-peaceful-teal text-primary-foreground rounded-lg font-cta font-bold text-lg transition-all duration-300 hover:scale-105 hover:shadow-lg pulse-gentle flex items-center space-x-2">
              <Icon name="HeartIcon" size={24} variant="solid" />
              <span>Make a Donation</span>
            </Link>
            <Link href="#volunteer-opportunities" className="px-8 py-4 bg-primary-foreground/10 backdrop-blur-sm text-primary-foreground border-2 border-primary-foreground/30 rounded-lg font-cta font-bold text-lg transition-all duration-300 hover:bg-primary-foreground/20 flex items-center space-x-2">
              <Icon name="HandRaisedIcon" size={24} variant="solid" />
              <span>Volunteer Today</span>
            </Link>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-primary-foreground/10 backdrop-blur-sm rounded-xl p-6 border border-primary-foreground/20">
              <div className="w-14 h-14 bg-peaceful-teal/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name="ShieldCheckIcon" size={28} className="text-peaceful-teal" variant="solid" />
              </div>
              <h3 className="text-lg font-cta font-bold text-primary-foreground mb-2">
                100% Transparent
              </h3>
              <p className="text-sm text-primary-foreground/80 font-body">
                Every dollar tracked from donation to delivery with real-time impact reporting
              </p>
            </div>

            <div className="bg-primary-foreground/10 backdrop-blur-sm rounded-xl p-6 border border-primary-foreground/20">
              <div className="w-14 h-14 bg-peaceful-teal/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name="BoltIcon" size={28} className="text-peaceful-teal" variant="solid" />
              </div>
              <h3 className="text-lg font-cta font-bold text-primary-foreground mb-2">
                Rapid Response
              </h3>
              <p className="text-sm text-primary-foreground/80 font-body">
                Emergency aid deployed within 24-48 hours of crisis identification
              </p>
            </div>

            <div className="bg-primary-foreground/10 backdrop-blur-sm rounded-xl p-6 border border-primary-foreground/20">
              <div className="w-14 h-14 bg-peaceful-teal/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name="GlobeAltIcon" size={28} className="text-peaceful-teal" variant="solid" />
              </div>
              <h3 className="text-lg font-cta font-bold text-primary-foreground mb-2">
                Global Reach
              </h3>
              <p className="text-sm text-primary-foreground/80 font-body">
                Active projects in 42 countries reaching 2.4M+ vulnerable individuals
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;